/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetBenefitCategories200ResponseBenefitCategoriesInner
 */
export interface GetBenefitCategories200ResponseBenefitCategoriesInner {
    /**
     * 
     * @type {number}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'iconImageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'categoryType': GetBenefitCategories200ResponseBenefitCategoriesInnerCategoryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'isPublished': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBenefitCategories200ResponseBenefitCategoriesInner
     */
    'updatedAt': string;
}

export const GetBenefitCategories200ResponseBenefitCategoriesInnerCategoryTypeEnum = {
    internal: 'INTERNAL',
    external: 'EXTERNAL'
} as const;

export type GetBenefitCategories200ResponseBenefitCategoriesInnerCategoryTypeEnum = typeof GetBenefitCategories200ResponseBenefitCategoriesInnerCategoryTypeEnum[keyof typeof GetBenefitCategories200ResponseBenefitCategoriesInnerCategoryTypeEnum];


